module.exports = __webpack_public_path__ + "static/media/Piercing-microdermal-forehead.98c3050f.png";